import { atom, getDefaultStore } from 'jotai';

export const screenWidthAtom = atom(window.innerWidth);

window.addEventListener('resize', () => {
  getDefaultStore().set(screenWidthAtom, window.innerWidth);
});
